assessment = function (id) {

	var objAssessment = {};
	var objDialog = dialog();
	var objValidation = validation();
	var objDom = dom();

	var selectIds = [];
	selectIds[0] = '#objective-category';
	selectIds[1] = '#objective-parent-category';
	selectIds[2] = '#entity-new-parent';

	var divId = '#curriculog-hierarchy-column-content';

	/* initialize growls */
	$('#growls').notify();


	/**
	 * Used to get the state of the assessments widget as a whole.
	 *
	 * @returns {Boolean} - True if there are any unsaved assessment items.
	 */
	objAssessment.hasUnsavedChanges = function() {
		return Boolean($('.section-fieldset.widget-assessment').data('unsaved_changes'));
	};

	/**
	 * Loops through each assessment item and checks its value against its cached value.
	 */
	objAssessment.detectChanges = _.throttle(function() {
		var field = $('.section-fieldset.widget-assessment'),
			unsaved_changes = false;

		field.find('.curriculog-smartfield-dropzone').each(function(index) {
			var assessment_item = $(this),
				textarea = assessment_item.find('textarea.field-placeholder');

			if (assessment_item.data('value') != textarea.val()) {
				unsaved_changes = true;
			}
		});

		field.data('unsaved_changes', unsaved_changes);

		if (unsaved_changes) {
			field.addClass('field-unsaved');
		} else {
			field.removeClass('field-unsaved');
		}

	}, 600);

	/**
	 * Used to cache the initial unchanged values of the assessment items.
	 */
	objAssessment.precacheValues = function() {
		var field = $('.section-fieldset.widget-assessment');
		field.find('.curriculog-smartfield-dropzone').each(function(index) {
			var assessment_item = $(this),
				textarea = assessment_item.find('textarea.field-placeholder');

			if ('value' in assessment_item.data()) {
				return;
			}

			assessment_item.data('value', textarea.val());
		});
	};


	/**
	 * Save each assessment item that has changes.
	 *
	 * @returns {Promise} - A combined promise representing every field save.
	 */
	objAssessment.saveAllChanges = function() {
		var field = $('.section-fieldset.widget-assessment'),
			field_id = field.data('id'),
			promises = [];

		field.find('.curriculog-smartfield-dropzone').each(function(index) {
			var assessment_item = $(this),
				textarea = assessment_item.find('textarea.field-placeholder');

			if (assessment_item.data('value') != textarea.val()) {
				promises.push(proposalObject.saveField(field_id, assessment_item.data('id')));
			}
		});
		return $.when.apply($, promises);
	};


	objAssessment.objectiveList = function(divId) {
		params = {
			display : 'ajaxList'
		};

		$.ajax({
			url: '/admin/assessment',
			type: 'GET',
			data: params,
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-hierarchy-column-content');
			},
			complete: function() {
				objDom.removeMask('#curriculog-hierarchy-column-content');
			},
			success: function(data) {
				$(divId + ' ul').contents().remove();
				$(divId + ' ul').append(data);
				$(divId + ' .category').each(function(i){
					$(this).attr('id','category-' + i);
				});
				$(divId + ' .objective').each(function(i){
					$(this).attr('id','objective-id-' + i);
				});
				objAssessment.verticalStretch();
				objAssessment.precacheValues();
			}
		});
		$.get('/admin/assessment', params, function(data) {
			//console.log("CALLED");
		});

	};

	objAssessment.objectiveDialog = function(divId, callback) {

		formatDialogName = function(item, level, selectId, parent) {
			if (item.name !== undefined) {
				var name = escapeUserInput(item.name);
				var classType = ' category';
			} else {
				var name = escapeUserInput(item.value);
				var classType = ' objective';
			}

			var parentClass = (+parent !== 0) ? parent : '';

			if (item.status === 'active') {
				// XXX This line is an abomination!
				$(selectId).append($('<li class="select-field"><button class="curriculog-add-widget value-' + item.id + classType + ' ' + parentClass + ' level-' + level + '" style="padding-left: '+ (level * 18) + 'px">' + name + '</button></li>'));
			}

			if ((item.objectives !== undefined) && (item.objectives.length > 0)) {
				parent = 'parent-' + item.id;
				$.each(item.objectives, function(index, objective) {
					formatDialogName(objective, level, divId, parent);
				});

			}

			if ((item.children !== undefined) && (item.children.length > 0)) {
				level += 1;
				parent = 'parent-' + item.id;
				// if children loop through children and add to select
				$.each(item.children, function(index3, itemChild) {
					formatDialogName(itemChild, level, divId, parent);
				});
			}
		};

		var parent = 0;
		$.get('/assessment.json', '', function(data) {
			$(divId).contents().remove();
			if (data.assessments.length === 0) {
				$(divId).append('<li>There are no assessments. Click Create New to write your own.</li>');
			} else {
				$.each(data.assessments, function(index2, assessment) {
					formatDialogName(assessment, 1, divId, parent);
				});
			}
			callback && callback();
		});


	};

	/*
	 * Function objectiveAction
	 * Purpose: clones a section (header with add row button) from fields.html.php
	 * and inserts it into the DOM above the "Add Section" button
	 */

	objAssessment.validateObjective = function() {

		$.validity.start();

		$('#objective-value').require();

		var result = $.validity.end();

		return result.valid;
	};

	objAssessment.createObjective = function() {

		var dialog = objDialog.createDOMDialog('objective-dialog', function(dialog, defaults) {
			defaults.buttons = {
				'Add Objective': function() {

					// Perform insert here
					var postData = {
						category : $('#objective-category').val(),
						status : ( !($('#objective-status').is(':checked')) ) ? 'inactive' : 'active',
						value : $('#objective-value').val()
					};

					if (objAssessment.validateObjective()) {
						$.post('/admin/assessment.json', postData, function(data) {
							if (data.id > 0) {
								objAssessment.objectiveList(divId);
							} else {
								growlError('Error', 'Your objective was not saved.');
							}
							$(dialog).dialog('close');
						});
					}

				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				objAssessment.cleanObjectiveForm();
			};
			$(dialog).dialog(defaults);

		});
	};

	objAssessment.updateObjective = function(id) {

		//Get the current item info
		id = (id).replace('objective-id-','');

		$.get('/admin/assessment:'+id+'.json', function(data) {
			$('#objective-id').val(data.objective.id);
			$('#objective-value').val(data.objective.value);

			var select;
			if (data.objective.categoryID > 0) {
				select = $('#objective-category option[value="' + data.objective.categoryID + '"]').attr('selected', 'selected');
			} else {
				select = $('#objective-category option[value=""]').attr('selected', 'selected');
			}

			$('#objective-status').prop('checked', data.objective.status === 'active');
		});

		var dialog = objDialog.createDOMDialog('objective-dialog', function(dialog, defaults) {
			defaults.buttons = {
				'Update Objective': function() {

					// Perform insert here
					var postData = {
						category : $('#objective-category').val(),
						status : ( !($('#objective-status').is(':checked')) ) ? 'inactive' : 'active',
						value : $('#objective-value').val()
					};

					if(objAssessment.validateObjective()) {
						$.ajax({
							url: '/admin/assessment:' + id + '.json',
							type: 'PUT',
							data: postData,
							success: function(data){
								if(data.id > 0) {
									objAssessment.objectiveList(divId);

								} else {
									growlError('Error', 'Your objective was not saved.');
								}
								$(dialog).dialog('close');
							}
						});
					}

				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				objAssessment.cleanObjectiveForm();
			};
			$(dialog).dialog(defaults);

		});
	};

	objAssessment.validateCategory = function() {

		$.validity.start();

		$('#objective-category-name').require();

		var result = $.validity.end();

		return result.valid;
	};

	objAssessment.createCategory = function() {

		id = myUniquer.create();

		var dialog = objDialog.createDOMDialog('objective-category-dialog', function(dialog, defaults) {
			defaults.buttons = {
				'Add Category': function() {

					// Perform insert here
					var category = {
						name:$('#objective-category-name').val(),
						parent: ($('#objective-parent-category').val() !== '') ? $('#objective-parent-category').val(): 0,
						status: ( !($('#objective-category-status').is(':checked')) ) ? 'inactive' : 'active'
					};

					if (objAssessment.validateCategory()) {
						$.post('/admin/assessment/category.json', category, function(data){
							if(data.id > 0) {
								objAssessment.getCategories(selectIds);
								objAssessment.objectiveList(divId);

							} else {
								$('#growls').notify('create', 'warning-template', {
									text: 'Your category was not saved.'
								});
							}

							$(dialog).dialog('close');
						});
					}

				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				objAssessment.cleanCategoryForm();
			};
			$(dialog).dialog(defaults);

		});
	};

	objAssessment.updateCategory = function(id) {
		//Get the current item info
		id = id.replace('category-id-','');
		$.get('/admin/assessment:' + id + '/category.json', function(data) {
			$('#objective-category-id').val(data.category.id);
			$('#objective-category-name').val(data.category.name);
			// Status checkbox
			$('#objective-category-status').prop('checked', data.category.status === 'active');
			var select;
			if (data.category.parent ===  null || data.category.parent === undefined) {
				select = $('#objective-parent-category option[value=""]').attr('selected','selected');
			} else {
				var pid = data.category.parent.categoryParentID;
				select = $('#objective-parent-category option[value="' + pid + '"]').attr('selected', 'selected');
			}
			// disable self as parent possibility
			$('#objective-parent-category option[value="' + id + '"]').attr('disabled', true);

		});

		var dialog = objDialog.createDOMDialog('objective-category-dialog', function(dialog, defaults) {
			defaults.buttons = {
				'Update Category': function() {

					// Perform insert here
					var category = {
						name:$('#objective-category-name').val(),
						status: (! ($('#objective-category-status').is(':checked')) ) ? 'inactive' : 'active',
						parent: $('#objective-parent-category').val(),
					};

					if ($('#objective-parent-category').val() === '') {
						delete category.parent;
					}

					if(objAssessment.validateCategory()) {

						$.ajax({
							url: '/admin/assessment:' + id + '/category.json',
							type: 'PUT',
							data: category,
							success: function(data) {
								if(data.id > 0) {
									objAssessment.getCategories(selectIds);
									objAssessment.objectiveList(divId);

								} else {
									$('#growls').notify('create', 'warning-template', {
										text: 'Your category was not saved.'
									});
								}
								$(dialog).dialog('close');
							}
						});
					}

				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				objAssessment.cleanCategoryForm();
			};
			$(dialog).dialog(defaults);

		});
	};

	objAssessment.cleanCategoryForm = function() {
		$('#objective-category-name').val('');
		$('#objective-category-status').prop('checked', true);
	};

	objAssessment.cleanObjectiveForm = function() {
		$('#objective-category').val('');
		$('#objective-value').val('');
		$('#objective-status').prop('checked', true);
	};

	objAssessment.getCategories = function(selectId) {
		if($.isArray(selectId)) {
			selectId = selectId.join(', ');
		}

		$.get('/admin/assessment/category.json', {}, function(data) {
			if(data.categories.length > 0) {
				$(selectId).contents().remove();
				$(selectId).append($('<option value="">No Parent Category</option>'));
				$.each(data.categories, function(index2, category) {
					objAssessment.formatName(category, 0, selectId);
				});
			} else {
				$(selectId).append($('<option value="">No Categories Available</option>'));
			}
		});
	};

	objAssessment.formatName = function(item, level, selectId) {

		try {
			escapedName = escapeUserInput(item.name);
			$(selectId).append($('<option style="padding-left: ' + (level * 18) + 'px"></option>').val(item.id).html(escapedName));

			if (('children' in item) && (item.children.length > 0)) {
				level += 1;

				// if children loop through children and add to select
				$.each(item.children, function(index3, itemChild) {
					objAssessment.formatName(itemChild, level, selectId);
				});
			}
		} catch(err) {
			console.log(err);
		}
	};

	objAssessment.deleteObjective = function(obj) {
		var id = $(obj).closest('.assessment').attr('class').match(/objective-id-(\d*)/)[1];
		var itemName = $(obj).closest('.assessment').children('.objective-info').text();
		itemName = escapeUserInput(itemName);

		$(obj).closest('li').addClass('curriculog-remove-warning-highlight');

		var dialog = objDialog.createBasicWarningDialog('remove-assessment', function(dialog, defaults) {

			// Message
			var message = 'You are deleting the following objective: <center><span class="strong">' + itemName + '</span></center>Are you sure you want to continue?';
			$(dialog).append(message);

			// Actions
			defaults.buttons = {
				'Remove Objective': function() {
					$.ajax({
						url: '/admin/assessment:'+ id + '/objective.json',
						type: 'DELETE',
						success: function(results){
							if(results.success > 0) {
								objAssessment.getCategories(selectIds);
								objAssessment.objectiveList(divId);

							} else {
								$('#growls').notify('create', 'warning-template', {
									text: 'Your objective was not deleted.'
								});
							}
						}
					});
					$(this).dialog('close');
				},
				Cancel: function() {
					$(obj).closest('li').removeClass('curriculog-remove-warning-highlight');
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	objAssessment.deleteCategory = function(obj) {
		var id = $(obj).closest('.assessment').attr('class').match(/category-id-(\d*)/)[1];
		var itemName = $(obj).closest('.assessment').children('.category-info').text();
		itemName = escapeUserInput(itemName);
		var itemLevel = ($(obj).closest('.assessment').attr('class')).match(/level-(\d*)/);

		//Check to see if entity has any of the following conditions
		var hasChildren = ($(obj).closest('li').next().find('ul').length > 0) ? true : false;
		var hasNoMoreParents = false;
		if (+itemLevel[1] === 0) {
			var itemsToReparent = $(obj).closest('li').next().find('ul li').length + 1;
			var objectives = $('.assessment span.objective-info').length;
			if (itemsToReparent + objectives < $('.assessment').length ) {
				// no problem
			} else {
				hasNoMoreParents = true;
			}
		}
		if ((hasChildren) && (hasNoMoreParents)) {
			objAssessment.noMoreParentsError(id, itemName);
		}

		else if (hasChildren) {
			objAssessment.hasChildrenError(id, itemName);
		} else {
			$(obj).closest('li').addClass('curriculog-remove-warning-highlight');

			var dialog = objDialog.createBasicWarningDialog('remove-assessment', function(dialog, defaults) {
				// Message
				escapedItemName = escapeUserInput(itemName);
				var message = 'You are deleting the <span class="strong">' + escapedItemName + '</span> Category. Are you sure you want to continue?';
				$(dialog).append(message);

				// Actions
				defaults.buttons = {
					'Remove Category': function() {
						$.ajax({
							url: '/admin/assessment:'+ id + '/category.json',
							data: {type:'remove'},
							type: 'DELETE',
							success: function(results){
								if(results.success > 0) {
									objAssessment.getCategories(selectIds);
									objAssessment.objectiveList(divId);

								} else {
									$('#growls').notify('create', 'warning-template', {
										text: 'Your Category was not deleted.'
									});
								}
							}
						});
						$(this).dialog('close');
					},
					Cancel: function() {
						$(obj).closest('li').removeClass('curriculog-remove-warning-highlight');
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);
			});
		}

	};

	objAssessment.noMoreParentsError = function(itemId, itemName) {
		// Categories only would make it here. Objectives have no 'parents'
		var dialog = objDialog.createBasicWarningDialog('no-more-parents', function(dialog, defaults) {
			// Message
			$(dialog).append('There are no eligible parents for the children of ' + itemName + '. Would you like to unparent all children from ' + itemName + ' and then delete it?');
			// Actions
			defaults.buttons = {
				'Remove Relationship and Delete Category': function() {
					// ID: Parent is same as ID
					var paramData = {
						type:'noparents'
					};
					$.ajax({
						url: '/admin/assessment:' + itemId + '/category.json',
						type: 'DELETE',
						data: paramData,
						success: function(result){
							if(result.success > 0) {
								objAssessment.getCategories(selectIds);
								objAssessment.objectiveList(divId);

							} else {
								var text = 'Your delete could not be completed.';
								$('#growls').notify('create', 'warning-template', {
									text: text
								});
							}
						}
					});
					$(this).dialog('close');
				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				$('.assessment').closest('li').removeClass('curriculog-remove-warning-highlight');
			};
			$(dialog).dialog(defaults);

		});
	};

	objAssessment.hasChildrenError = function(itemId, itemName) {
		$('.category-id-'+itemId).closest('li').addClass('curriculog-remove-warning-highlight');

		var dialog = objDialog.createDOMWarningDialog('assessment-reparent-dialog', function(dialog, defaults) {
			//Get List of children
			var hasChildren = $('.category-id-'+itemId).closest('li').next().children('ul');

			children = [];
			childrenDivs = $('.category-id-'+itemId).parent('li').nextAll('li');
			$.each(childrenDivs, function(index, child) {

				if ($(child).children('ul').length !== 0) {
					$(child).children('ul').children('li').each(function() {
						if ($(this).children('ul').length === 0) {
							children.push($(this));
						}
					});
				} else {
					return false;
				}
			});

			var childrenList = '';
			for (var x = 0; x < children.length; x++) {
				var childName = $(children[x]).children('.assessment').children('span').text();
				childName = escapeUserInput(childName);
				childrenList += '<li>' + childName + '</li>';
			}
			$('#entity-children').html(childrenList);
			$('#assessment-reparent-dialog .entity-name').html(itemName);

			// disable category we are removing and any children with it
			$('#entity-new-parent option[value="' + itemId + '"]').prop('disabled', true);

			$.each(children, function(index, child) {

				var childId = $(child).children('.assessment').attr('class').match(/category-id-(\d*)/);

				if (childId !== null && childId !== undefined) {
					$('#entity-new-parent option[value="' + childId[1] + '"]').prop('disabled', true);
				}
			});

			// Actions
			defaults.buttons = {
				'Reparent children and Delete Category': function() {
					// ID will not match
					var paramData = {
						newParent : $('#entity-new-parent').val(),
						type: 'reparent'
					};
					$.ajax({
						url: '/admin/assessment:' + itemId + '/category.json',
						type: 'DELETE',
						data: paramData,
						success: function(result) {
							if(result.success > 0) {
								objAssessment.getCategories(selectIds);
								objAssessment.objectiveList(divId);

							} else {
								var text = 'Your delete could not be completed.';
								$('#growls').notify('create', 'warning-template', {
									text: text
								});
							}
						}
					});

					$(this).dialog('close');
				},
				Cancel: function() {
					objAssessment.getCategories(selectIds);
					$(this).dialog('close');
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				$('.category-id-'+itemId).closest('li').removeClass('curriculog-remove-warning-highlight');
			};
			$(dialog).dialog(defaults);

		});
	};

	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***						PROPOSAL METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	// USED BY SMARTFIELD DIALOG TO ADD ASSESSMENTS TO PROPOSAL FORM

	objAssessment.newProposalAssessment = function(obj, items) {
		// If we are on the program map then we do things slightly different.
		if ($('.map-page').length) {
			return objAssessment.newProgramMapAssessment(obj, items);
		}

		var assessments = [],
			data = {},
			orderIndex = 0;

		// Get the order index
		if ($('.widget-assessment .curriculog-smartfield-dropzone').length > 0) {
			orderIndex = $('.widget-assessment .curriculog-smartfield-dropzone').length;
		}

		var curriculumID;
		if (typeof app.cv !== 'undefined') {
			curriculumID = app.cv.collection.root().get('id');
		} else {
			curriculumID = null;
		}

		$.each(items, function(index, item) {
			assessments[index] = {
				category: item.categoryId,
				categoryName: item.categoryName,
				objectiveID: (item.assessmentId !== '') ? item.assessmentId : 0,
				proposalFieldID: $('.add-assessment-item').attr('class').match(/field-(\d*)/)[1],
				inventoryID: curriculumID,
				value: item.assessmentValue,
				status: 'active',
				orderIndex: (+orderIndex) + (+index),
				type: ($('#status').val() === 'unlaunched') ? 'original' : 'edit'
			};

		});

		data.assessments = JSON.stringify(assessments);
		data.editList = JSON.stringify([]);
		data.proposalStatus = $('#status').val();
		data.display = 'getAssessments';

		// Ajax the assessments
		var xhr = $.ajax({
			url: '/assessment/saveAssessments.ajax?display=' + data.display,
			type: 'PUT',
			data: data,
			beforeSend: function() {
				objDom.addMask('.widget-assessment');
			},
			success: function(data) {
				objDom.removeMask('.widget-assessment');

				// append the new assessments to the DOM
				assessmentsData = $('<div id="assessment-container"></div>');
				$(data).find('.curriculog-smartfield-dropzone').each(function(index, item) {
					if (index > orderIndex - 1) {
						$(assessmentsData).append($(item));
					}
				});


				if ($.inArray($('#status').val(), ['unlaunched']) > -1) {
					$('.widget-assessment').replaceWith(data);
					proposalObject.bindAssessmentEvents('edit');
					objAssessment.verticalStretch();

				} else {
					if ($('.widget-assessment .no-item').length > 0) {
						var fieldId = $('.add-assessment-item').attr('class').match(/field-(\d*)/)[1];
						var canEdit = proposalObject.getCanEdit();
						proposalObject.editField(fieldId, canEdit);

					} else {
						var newAssessments = [];
						$(assessmentsData).find('.ckeditor').each(function(index, item) {
							newAssessments.push('#' + $(item).attr('id'));
						});

						$(assessmentsData).contents().insertBefore($('.widget-assessment .fieldset-buttons.add-cancel'));

						proposalObject.bindAssessmentEvents('edit', newAssessments);

					}

					// slide buttons down, if they exist
					var buttons = $('.widget-assessment').find('.fieldset-buttons');
					$(buttons).slideDown(200, function() {
						objAssessment.verticalStretch();
					});
				}

				objAssessment.precacheValues();
			}
		});
		return xhr;
	};

	objAssessment.newProgramMapAssessment = function(obj, items) {
		var assessments = [],
			data = {},
			orderIndex = 0;

		var course = $(obj).closest('tr').attr('class').match(/(course-[A-Za-z0-9])/);
		if ($('.' + course + ' .assessment').length > 0) {
			orderIndex = $('.' + course + ' .assessment').length - 1;
		}

		$.each(items, function(index, item) {
			assessments[index] = {
				category: item.categoryId,
				categoryName: item.categoryName,
				objectiveID: (item.assessmentId !== '') ? item.assessmentId : 0,
				proposalFieldID: 0,
				inventoryID: $(obj).attr('class').match(/inventory-(\d*)/)[1],
				value: item.assessmentValue,
				status: 'active',
				orderIndex: orderIndex
			};
		});

		data.assessments = JSON.stringify(assessments);
		data.editList = JSON.stringify([]);
		data.proposalStatus = $('#status').val();
		data.display = 'getAssessments';

		// Ajax the assessments
		var xhr = $.ajax({
			url: '/assessment/saveAssessments.ajax?display=' + data.display,
			type: 'PUT',
			data: data,
			beforeSend: function() {
				var inventorySelector = $(obj).parents('div').parents('td');
				objDom.addMask(inventorySelector);
			},
			success: function(data) {
				proposalObject.getMapType(0);
				objAssessment.precacheValues();
			}
		});
		return xhr;
	};

	objAssessment.gatherAssessments = function(obj, newAssessments) {
		var items = {};
		$('#smartfield-select li.active').each(function(i){
			// Pick an objective?
			var assessment = $(this).children('button');
			var categoryId = ($(assessment).attr('class').match(/parent-(\d*)/) !== null) ? $(assessment).attr('class').match(/parent-(\d*)/)[1] : $(assessment).attr('class').match(/value-(\d*)/)[1];
			var level = parseInt($(assessment).attr('class').match(/level-(\d*)/)[1], 10);

			// Cycle through the parents of the category to build the category name for the DOM
			var categories = [];
			var start = 0;
			if (!$(assessment).hasClass('objective')) {
				categories[0] = $(assessment).text();
				start = 1;
			} else {
				start = 0;
			}

			var parentId = categoryId;
			var x;
			for (x = start; x < level; x++) {
				categories[x] = $('#smartfield-select li button.category.value-'+parentId).text();
				var hasParent =  ($(assessment).attr('class').match(/parent-(\d*)/) !== null) ? true : false;
				// If the selected item is level 2 or more, get the next parent and cycle through again
				if ((hasParent) && (parseInt($('#smartfield-select li button.category.value-'+parentId).attr('class').match(/level-(\d*)/)[1], 10) > 1)) {
					parentId = $('#smartfield-select li button.category.value-'+parentId).attr('class').match(/parent-(\d*)/)[1];
				}
			}
			categories.reverse();

			var categoryName = '';
			for(x = 0; x < categories.length; x++) {
				categoryName += (categoryName.length > 0) ? ' &gt; ' + categories[x] : categories[x];
			}

			if ($(assessment).hasClass('objective')) {
				items[i] = {
					categoryId : categoryId,
					categoryName : categoryName,
					assessmentId : $(assessment).attr('class').match(/value-(\d*)/)[1],
					assessmentValue : $(assessment).html()
				};
			} else if ($(assessment).hasClass('category') && newAssessments) {
				items[i] = {
					categoryId : categoryId,
					categoryName : categoryName,
					assessmentId : '',
					assessmentValue : ''
				};
			}
		});

		if($.isEmptyObject(items)) {
			items[0] = {
				categoryId : '',
				categoryName : '',
				assessmentId : '',
				assessmentValue : ''
			};
		}

		assessmentObject.newProposalAssessment(obj, items);

	};

	/*
	 * saveProposalAssessment will save an individual assessment ON A PROPOSAL (not map) and reload just that fieldset
	 */

	objAssessment.saveProposalAssessment = function(fieldId, orderIndex, editList) {
		// get the index for the assessment
		var index = 0;
		$('.field-'+ fieldId +' .curriculog-smartfield-dropzone').each(function(i) {
			var match = $(this).attr('class').match(new RegExp('field-' + fieldId + '-' + orderIndex));
			if (match !== undefined && match !== null) {
				index = i;
			}
		});
		data = {};
		assessments = [];
		assessments[0] = {
			id: +orderIndex,
			category: +$('input[id="field-'+ fieldId +'-'+ orderIndex +'-category"]').val(),
			categoryName: $('.field-'+ fieldId +'-'+ orderIndex ).find('.category').html(),
			objectiveID: +$('input[id="field-'+fieldId+'-'+orderIndex+'-objective"]').val(),
			proposalFieldID: +fieldId,
			inventoryID: $('#inventoryId').val(),
			value: $('#field-'+fieldId+'-'+orderIndex+'-assessment').val(),
			status: 'active',
			orderIndex: index
		};
		data.assessments = JSON.stringify(assessments);
		data.editList = JSON.stringify(editList);
		data.proposalStatus = $('#status').val();
		data.display = 'conflictDiff';

		// Ajax the assessment
		return $.ajax({
			url: '/assessment/saveAssessments.ajax',
			type: 'PUT',
			data: data,
			//contentType: 'application/json',
			beforeSend: function() {
				objDom.addMask('.field-'+ fieldId +'-'+ orderIndex);
			},
			success: function(data) {
				objDom.removeMask('.field-'+ fieldId +'-'+ orderIndex);

				// if conflict, data will include the html for the conflict dialog and save was unsuccessful
				if (data.length > 11) {
					proposalObject.showConflict(data, fieldId, orderIndex, 'assessment');
				} else {
					// update value cache. See detectChanges() for details
					var textarea = $('#field-'+fieldId+'-'+orderIndex+'-assessment');
					textarea.closest('.curriculog-smartfield-dropzone').data('value', textarea.val());
					objAssessment.detectChanges();
				}

			}
		});


	};

	objAssessment.saveMapAssessment = function(obj) {
		var xhr,
			selector = $(obj).parents('td'),
			proposalId = objAssessment.getProposalId(),
			assessment = {
				id: $(obj).siblings('input[name="id"]').val(),
				category: $(obj).siblings('input[name="categoryID"]').val(),
				categoryName: $(obj).siblings('input[name="categoryName"]').val(),
				objectiveID: $(obj).siblings('input[name="objectiveID"]').val(),
				proposalFieldID: 0,
				inventoryID: $(obj).siblings('input[name="inventoryID"]').val(),
				value: $(obj).val(),
				status: 'active',
				orderIndex: Number($(obj).siblings('input[name="orderIndex"]').val())
			};

		xhr = $.ajax({
			url: '/assessment:' + proposalId + '/saveMapAssessment.json',
			type: 'PUT',
			data: JSON.stringify(assessment),
			contentType: 'application/json',
			beforeSend: function() {
				objDom.addMask(selector);
			},
			success: function(result) {
				objDom.removeMask(selector);
				$(obj).closest('.curriculog-smartfield-dropzone').data('value', $(obj).val());
				objAssessment.detectChanges();
			}
		});

		// Return the jqXHR, so we can add callbacks to the queue.
		return xhr;
	};


	objAssessment.getProposalAssessment = function(id) {
		// This was created for getting the original assessment value when you
		// cancel editing a custom assessment, so it doesn't update the whole
		// DOM, just the value field.
		var xhr = $.ajax({
			type: 'GET',
			url: '/proposalAssessment:' + id + '.json',
			success: function(data) {
				// Just update the value field here.
				var value = data.assessment.value;
				var av = $('#assessment-id-' + id + ' [name="value"]').val(value);
				objAssessment.precacheValues();
			}
		});
		return xhr;
	};


	/**
	 * Returns the proposals id via backbone model with a fallback to the dom.
	 *
	 * @returns {Integer} proposal id
	 */
	objAssessment.getProposalId = function() {
		if (app.formView) {
			return app.formView.model.id;
		}
		return Number($('#proposalId').val());
	};


	objAssessment.removeProposalAssessment = function(obj, isTracked) {
		//var isInventory = ($('#curriculog-view-map').hasClass('active')) ? true : false;
		//var isTracked = (isTracked) ? true : false;
		var isInventory = ($('.map-page').length > 0) ? true : false,
			proposalId = objAssessment.getProposalId(),
			assessment = $(obj).attr('class').match(/(assessment-)(\d*)/),
			assessmentId,
			fieldId;

		if (isInventory) {
			$('.'+ assessment[1] + assessment[2]).addClass('curriculog-remove-warning-highlight');
			assessmentId = assessment[2];
		} else {
			$(obj).closest('.curriculog-smartfield-dropzone').addClass('curriculog-remove-warning-highlight');
			var id = $(obj).closest('.curriculog-smartfield-dropzone').find('input[id$="category"]').attr('id').match(/field-(\d*)-(\d*)-category/);
			fieldId = id[1];
			assessmentId = id[2];
		}


		var dialog = objDialog.createBasicWarningDialog('remove-assessment', function(dialog, defaults) {

			var assessment_widget =  $('.widget-assessment');
			var required = assessment_widget.data('required');
			defaults.buttons = {};

			if(assessment_widget[0].children.length == 2 && assessment_widget.data('required') == 1){
				var text = 'This field is required. A new assessment must be added before deleting this item.'
			}

			else {
				var text = 'Are you sure you want to remove this assessment?';
				defaults.buttons['Remove Assessment'] = function() {

					var data = {
						id: Number(assessmentId),
						proposalStatus: $('#status').val(),
						editList: JSON.stringify([0])
					};
	
					// Ajax the assessments
					var display = (isInventory) ? 'viewMap' : 'getAssessments';
					$.ajax({
						url: '/assessment:'+ proposalId + '/deleteAssessment.ajax?display=' + display,
						type: 'PUT',
						data: data,
						beforeSend: function() {
							objDom.addMask('.field-'+ fieldId + '-' + assessmentId);
						},
						success: function(data) {
							objDom.removeMask('.field-'+ fieldId + '-' + assessmentId);
	
							if(isInventory) {
								//proposalObject.switchProposalView('map', 0);
								proposalObject.getMapType(0);
	
							} else {
	
								if ($.inArray($('#status').val(), ['unlaunched']) > -1) {
									$('.field-' + fieldId).replaceWith(data);
									proposalObject.bindAssessmentEvents('edit');
	
								} else {
	
									if ($('.widget-assessment .curriculog-smartfield-dropzone').length === 1) {
										// no more assessments. take the code from ajax
										var canEdit = proposalObject.getCanEdit();
										proposalObject.editField(fieldId, canEdit);
	
									} else {
										// remove the assessment only from the DOM
										$('.field-'+ fieldId + '-' + assessmentId).remove();
	
										// if legend was removed, add into the first element
										if ($('.widget-assessment .legend').length === 0) {
											legend = $(data).find('.legend');
											$(legend).insertBefore($('.widget-assessment .curriculog-smartfield-dropzone:first .option-groups'));
										}
									}
								}
							}
	
							objAssessment.verticalStretch();
							objAssessment.precacheValues();
							objAssessment.detectChanges();
	
							$(dialog).dialog('close');
	
						}
					});
	
				};

			}

			$(dialog).append(text);
			
			defaults.buttons['Cancel'] = function(){
				$(this).dialog('close');
			}
			// Cleanup
			defaults.close = function(event, ui) {
				$(obj).closest('.curriculog-smartfield-dropzone').removeClass('curriculog-remove-warning-highlight');
				if(isInventory) {
					$('.'+ assessment[1] + assessment[2]).removeClass('curriculog-remove-warning-highlight');
				}
				$(this).remove();
			};

			$(dialog).dialog(defaults);

		});

	};


	objAssessment.verticalStretch = function() {
		var col1 = '#curriculog-fields-column-content';
		var col2 = '#curriculog-steps-column-content';
		domObject = dom();
		domObject.verticalStretchForm(col1, col2, function(){
			if ($('#comments-list').size() > 0) {
				$('#comments-list').parent()
					.css('maxHeight', $('#curriculog-fields-column-content').height() - 150)
					.css('height', $('#comments-list').css('height'));
			}
		});
	};


	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************
	// ***
	// ***						VALIDATION METHODS
	// ***
	// ********************************************************************************
	// ********************************************************************************
	// ********************************************************************************

	/**
	 * Validation
	 */
	objAssessment.unsavedChanges = function(fieldId) {
		$.ajax({
			//url: '/proposalField:' + fieldId + '/getField.json',
			url: '/proposalField:' + fieldId + '/get.json',
			data: {returnDict: 1, showMarkup: 0},
			type: 'GET',
			success: function(data) {
				$(data.field.assessments).each(function(index, item) {
					// check the value of each against its present value.
					var assessmentId = 'field-' + item.proposalFieldID + '-' + item.id + '-assessment';

					var hasErrors = false;
					if ($('#' + assessmentId).closest('.option-groups').find('.error').length > 0) {
						hasErrors = true;
					}
					var error;
					if ( ($('#' + assessmentId).val() === '') && (! hasErrors) ) {

						// no value? error
						error = '<span id="' + assessmentId + 'Error" class="error empty-value">Assessments cannot be empty</span>';
						$('#' + assessmentId).closest('.option-groups').append(error);

					} else if (item.value !== $('#' + assessmentId).val() && !hasErrors) {
						// different value? error
						error = '<span id="'+ assessmentId + 'Error" class="error">This field has unsaved changes</span>';
						$('#' + assessmentId).closest('.option-groups').append(error);

					}

				});

				var dialog;
				// if error, throw dialog
				if ($('.field-' + fieldId + ' .empty-value').length > 0) {

					objAssessment.verticalStretch();

					dialog = objDialog.createDOMWarningDialog('unsaved-assessment-changes', function(dialog, defaults) {
						$('#unsaved-assessment-changes .save-changes').hide();

						defaults.buttons = {
							'Abandon Changes': function() {
								proposalObject.editField(fieldId, 0);
								$(dialog).dialog('close');
							},
							'Cancel': function() {
								$(dialog).dialog('close');
							}
						};


						$(dialog).dialog(defaults);
					});

				} else if ($('.field-' + fieldId + ' .error').length > 0) {

					objAssessment.verticalStretch();

					dialog = objDialog.createDOMWarningDialog('unsaved-assessment-changes', function(dialog, defaults) {

						$('#unsaved-assessment-changes .save-changes').show();

						defaults.buttons = {
							'Save All Changes': function() {

								$('.field-' + fieldId + ' .curriculog-smartfield-dropzone').each(function(index) {
									var field = $(this).find('.field-placeholder').attr('id').match(/field-(\w*)-(\w*)-assessment/);
									proposalObject.saveField(field[1], field[2]);
								});

								proposalObject.editField(fieldId, 0);

								$(dialog).dialog('close');
							},
							'Abandon Changes': function() {
								proposalObject.editField(fieldId, 0);
								$(dialog).dialog('close');
							},
							'Cancel': function() {
								$(dialog).dialog('close');
							}
						};

						$(dialog).dialog(defaults);
					});
				} else {
					// no errors. Exit safely
					proposalObject.editField(fieldId, 0);
				}
			}
		});
	};

	objAssessment.noEmptyAssessments = function(assessment, type) {
		var required = false,
			elementValue = $.trim($(assessment).val());

		if (objValidation.isEmpty(elementValue)) {
			required = true;
		}

		return objValidation.updateForm(assessment, true, required, type, function () {
			objAssessment.verticalStretch();
			$(assessment).removeClass('error');
		});


	};



	objAssessment.validate = function(input, type) {
		var elementValue = $.trim($(input).val());

		var required = false;

		if ( objValidation.isEmpty(elementValue) ) {
			required = true;
		}

		return objValidation.updateForm(input, true, required, type, function(){
				$(input).parents('fieldset:first').removeClass('error');
			});

	};


	return objAssessment;
};
